/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var langs   = require('../langs.full'),
    data    = [],
    gettext = require('mag-gettext').gettext,
    lang;

for ( lang in langs['1'] ) {
    data.push({
        value: lang,
        name: langs['1'][lang].local + ' (' + langs['1'][lang].name + ')'
    });
}

function save ( val ) {
    var langToSave;

    langToSave = langs.getLangByCode(val);

    if ( !langToSave ) {
        return;
    }

    if ( top.stbPlayerManager && top.stbPlayerManager.list ) {
        top.stbPlayerManager.list.forEach(function ( player ) {
            player.subtitlesPrimaryLanguage = langToSave['1'];
            player.subtitleLanguages = [langToSave['1'], langToSave['2T'], langToSave['2B']];

        });
    } else {
        top.gSTB.SetSubtitleLangs(val); //eslint-disable-line
    }
}


module.exports = function ( app ) {
    return {
        id: 'subtitlesLangs',
        name: gettext('Primary subtitle language'),
        description: gettext('Setting the default subtitle language. If the default subtitle language is not selected for a video you are playing, then subtitles will not be displayed.'), //eslint-disable-line
        icon: 'theme-icon-languages',
        data: {
            subtitlesLang: 'en'
        },
        saveImmediate: true,
        prepareForRender: function ( currentValue, callback ) {
            data.forEach(function ( item ) {
                item.selected = item.value === currentValue.subtitlesLang;
            });

            callback(data);
        },
        prepareForSave: function ( value, callback ) {
            this.data.subtitlesLang = value;

            save(value);
            callback();
        },
        render: app.api.renders.popupSelect,
        parent: 'playback'
    };
};

module.exports.setValue = save;
